import type { CSSProperties } from "react";
import { ICON_REGISTRY, FallbackIcon } from "./iconRegistry";

/* Bridges the prototype's kebab-case `name` API to lucide-react components.
   Backed by an explicit registry (iconRegistry.ts) of only the icons the app
   uses, so Rollup tree-shakes the rest of lucide-react out of the bundle. */
export function Icon({
  name,
  size = 16,
  strokeWidth = 1.8,
  className,
  style,
  color,
}: {
  name: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
  style?: CSSProperties;
  color?: string;
}) {
  const Cmp = ICON_REGISTRY[name] ?? FallbackIcon;
  return (
    <span className={"ic " + (className || "")} style={{ display: "inline-flex", color, ...style }}>
      <Cmp size={size} strokeWidth={strokeWidth} />
    </span>
  );
}
